import styled from "styled-components";
import Button from "./Button";

const StyledCommentButton = styled(Button)`
  width: 704px;
  height: 40px;
  margin-top: 10px;
  border: none;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 4px 3px 0px gray;
`;

export default StyledCommentButton;
